<div class="header">
  <h2>{{ "pages.analytics.realtime.title" | translate }}</h2>
  <div class="filters">
    <app-tutor-filter-control
      alAnchor="analytics.agent-filter"
      [analyticsPage]="'live'"
    ></app-tutor-filter-control>
    <div class="refresh-indicator">
      <app-circle-progress
        [onStart]="circularProgressStart"
        [progressTime]="refreshTime"
      ></app-circle-progress>
    </div>
  </div>
</div>

<div class="grid">
  <div class="sub-grid">
    <app-realtime-kpis alAnchor="analytics.live-kpis"></app-realtime-kpis>

    <div>
      <nb-card>
        <nb-card-header>
          <app-chart-header
            [title]="'charts.titles.realtimeCurrentVsPeakUsers' | translate"
            [infoText]="
              'charts.descriptions.realtimeCurrentVsPeakUsers' | translate
            "
          ></app-chart-header>
        </nb-card-header>
        <nb-card-body>
          <app-gauge-realtime-current-vs-peak-users></app-gauge-realtime-current-vs-peak-users>
        </nb-card-body>
      </nb-card>
    </div>
    <div class="col-span-2">
      <nb-card>
        <nb-card-header>
          <app-chart-header
            [title]="'charts.titles.realTimeSessionsPerMinute' | translate"
            [infoText]="
              'charts.descriptions.realTimeSessionsPerMinute' | translate
            "
            [isDemo]="analyticsService.isDemo('realTimeSessionsPerMinute')"
          ></app-chart-header>
        </nb-card-header>
        <nb-card-body>
          <app-bar-realtime-sessions-per-minute></app-bar-realtime-sessions-per-minute>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
  <div>
    <nb-card class="max-height">
      <nb-card-header>
        <app-chart-header
          [title]="'charts.titles.realtimeFeed' | translate"
          [infoText]="'charts.descriptions.realtimeFeed' | translate"
          [isDemo]="analyticsService.isDemo('realTimeEventsFeed')"
        ></app-chart-header>
      </nb-card-header>
      <nb-card-body>
        <app-realtime-feed></app-realtime-feed>
      </nb-card-body>
    </nb-card>
  </div>
</div>
